import storeInit from "storeInit";
import {get} from "lodash";

export default function workshopSettingsIsEnabled(settingPath){
  const state = storeInit.getState();

  return get(state.workshop.settings, settingPath);
}